import React from 'react'
import Header from '../../headerone/Main'
import Breadcrumb from '../../Breadcrumb/Main'
import Dualdegree_curriculumEle from './Dualdegree_curriculumEle'


function Main() {
    return (
      <>
          <Header/>
        <Breadcrumb title="Home" subtitle="Curriculum"/>
        <Dualdegree_curriculumEle />
      </>
    )
  }
  
  export default Main